interface StepCardProps {
  number: number;
  title: string;
  description: string;
  isLast?: boolean;
}

export function StepCard({ number, title, description, isLast = false }: StepCardProps) {
  return (
    <div className="relative flex gap-6">
      {/* Step Number */}
      <div className="flex-shrink-0">
        <div className="w-12 h-12 bg-gold-500 rounded-full flex items-center justify-center text-navy-900 font-bold text-lg">
          {number}
        </div>
        {/* Connector Line (hidden for last item) */}
        {!isLast && (
          <div className="hidden lg:block w-0.5 h-full bg-gold-200 mx-auto mt-4"></div>
        )}
      </div>

      {/* Content */}
      <div className="pb-12 lg:pb-16">
        <h3 className="text-xl font-bold text-navy-900 mb-2">{title}</h3>
        <p className="text-neutral-600 leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
